import rtcp from '../utils/rtcp'

const updateFpsOptimizationActivation = (
    isFpsOptimizationEnabled: boolean
): void => {
    rtcp.inputSend({
        id: 'GRABBER_OPTIMIZE',
        data: isFpsOptimizationEnabled,
    })
}

const updateBitrate = (streamBitrateInMegabytesPerSecond: number): void => {
    rtcp.inputSend({
        id: 'STREAM_QUALITY',
        data: streamBitrateInMegabytesPerSecond,
    })
}

const updateResolution = (width: number, height: number): void => {
    rtcp.inputSend({
        id: 'DISPLAYSETCONFIG',
        data: JSON.stringify({
            width,
            height,
        }),
    })
}

const enableCursorCapturedMode = (): void => {
    rtcp.inputSend({
        id: 'MOUSEMODE',
        data: JSON.stringify({
            mousemode: 'SERVER',
        }),
    })
}

const disableCursorCapturedMode = (): void => {
    rtcp.inputSend({
        id: 'MOUSEMODE',
        data: JSON.stringify({
            mousemode: 'CLIENT',
        }),
    })
}

export default {
    updateFpsOptimizationActivation,
    updateBitrate,
    updateResolution,
    enableCursorCapturedMode,
    disableCursorCapturedMode,
}
